<template>
  <div class="carCmp full-height linear-main3">
    <ld-header
      :transparent="true"
      :title="$t('A127','预订完成')"
      :white="true"
      @click-left="$router.push({path:'/car/carQuery'})"
    />
    <div class="pad-8">
      <div class="white  pad-b-20">
        <div class="pad-8">
          <div class="font24 font-lg pad-b-5">
            <ld-icon
              type="icondingzuoshj-icon-Reser"
              size="30"
              class="order-status__icon"
            />
            <span v-if="orderDetail.orderStatus == 0">
              已提交
            </span>
            <span v-if="orderDetail.orderStatus == 1">
              已派车
            </span>
            <span v-if="orderDetail.orderStatus == 2">
              改派中
            </span>
            <span v-if="orderDetail.orderStatus == 3">
              司机已出发
            </span>
            <span v-if="orderDetail.orderStatus == 4">
              司机已到达
            </span>
            <span v-if="orderDetail.orderStatus == 5">
              开始服务
            </span>
            <span v-if="orderDetail.orderStatus == 6">
              结束服务
            </span>
            <span v-if="orderDetail.orderStatus == 7">
              司机取消
            </span>
            <span v-if="orderDetail.orderStatus == 8">
              乘客取消
            </span>
            <span v-if="orderDetail.orderStatus == 9">
              拒单
            </span>
          </div>
          <p v-if="orderDetail.orderStatus == 0"> {{ $t('H204','订单已成功提交') }}</p>
        </div>
      </div>

      <van-cell class="m-b-5">
        {{ $t('F001','订单号') }} : {{ orderDetail.orderNo }}
        <span
          class="main-color fr"
          @click="$router.push({path:'/car/carOrderDetail',query: {'orderId': orderDetail.id}})"
        >{{ $t('B011','查看订单') }}</span>
      </van-cell>
      <van-field :label="$t('Information','用车信息')">
        <span slot="input">
          {{ orderDetail.cityName }} -
          {{ orderDetail.orderTypeName }}
          &nbsp;&nbsp;
          {{ orderDetail.vehicleTypeName }}
        </span>
      </van-field>

      <van-cell>
        <van-row>
          <van-col span="5">
            {{ $t('J009','用车时间') }}
          </van-col>
          <van-col
            span="19"
            class="gray"
          >
            <div>{{ orderDetail.startTime }}</div>
            <div>注：出发时间仅为参考，具体送机出发时间由接车司机联系通知。</div>
          </van-col>
        </van-row>
      </van-cell>

      <van-field
        label="包车天数"
        v-if="carSearchInfo.useType==4"
      >
        <span slot="input">{{ carSearchInfo.useDays }}天</span>
      </van-field>

      <van-field
        :label="$t('J023','上车地点')"
        v-if="carSearchInfo.useType==4"
      >
        <span slot="input">{{ orderDetail.scdd }}</span>
      </van-field>

      <div v-else>
        <van-cell>
          <van-row
            type="flex"
            align="center"
          >
            <van-col span="5">
              <div>{{ $t('J023','上车地点') }}</div>
            </van-col>
            <van-col span="2">
              <div>
                <img
                  src="~Assets/images/car/start.png"
                  alt="上车地点"
                  width="20"
                  class="vertical-middle"
                >
              </div>
            </van-col>
            <van-col span="17">
              <div>{{ scCity }}  {{ orderDetail.scddPoi }}</div>
              <div class="font12 gray">
                {{ orderDetail.scdd?(orderDetail.scdd.split('|')[1]):'' }}
              </div>
              <div
                class="font12 gray"
                v-show="carSearchInfo.useType==0"
              >
                {{ carSearchInfo.flightNo }}航班预计 {{ carSearchInfo.arriveTime }}到达
              </div>
            </van-col>
          </van-row>
        </van-cell>
        <van-cell>
          <van-row
            type="flex"
            align="center"
          >
            <van-col span="5">
              <div>{{ $t('J024','下车地点') }}</div>
            </van-col>
            <van-col span="2">
              <div>
                <img
                  src="~Assets/images/car/end.png"
                  alt="下车地点"
                  width="21"
                  class="vertical-middle"
                >
              </div>
            </van-col>
            <van-col span="17">
              <div> {{ orderDetail.xcddPoi }}</div>
              <div class="font12 gray">
                {{ orderDetail.xcdd?(orderDetail.xcdd.split('|')[1]):'' }}
              </div>
            </van-col>
          </van-row>
        </van-cell>
      </div>

      <van-cell class="m-b-5">
        <van-row>
          <van-col span="5">
            {{ $t('Car','用车人') }}
          </van-col>
          <van-col
            span="19"
            class="gray"
          >
            {{ orderDetail.empName }}
            {{ orderDetail.phoneNumber }}
          </van-col>
        </van-row>
      </van-cell>

      <van-cell
        :title="$t('F011','差旅信息')"
        v-if="orderDetail.costCenterName ||orderDetail.projectName || orderDetail.subjectCode"/>
      <van-cell v-if="orderDetail.costCenterName">
        <van-row>
          <van-col span="5">
            {{ $t('K001','成本中心') }}
          </van-col>
          <van-col
            span="19"
            class="gray"
          >
            {{ orderDetail.costCenterName }}
          </van-col>
        </van-row>
      </van-cell>
      <van-cell v-if="orderDetail.projectName">
        <van-row
          type="flex"
          align="center">
          <van-col span="5">
            {{ $t('K002','项目') }}
          </van-col>
          <van-col
            span="19"
            class="gray"
          >
            <div>{{ orderDetail.projectName }}</div>
            <div>{{ orderDetail.projectCode }}</div>
          </van-col>
        </van-row>
      </van-cell>
      <van-cell class="m-b-5" v-if="orderDetail.subjectCode">
        <van-row>
          <van-col span="5">
            {{ $t('F054','科目码') }}
          </van-col>
          <van-col
            span="19"
            class="gray"
          >
            {{ orderDetail.subjectCode }}
          </van-col>
        </van-row>
      </van-cell>

      <ld-button
        detault
        style="margin-bottom:50px;"
        to="/car/carQuery"
      >
        {{ $t('B012','继续预订') }}
      </ld-button>
    </div>

    <!--  -->
    <ld-tabbar
      class="bg-white shadow pad-lr-10"
      :price-list="priceList"
      ref="tabbar"
    >
      <van-row
        class="full-width"
        type="flex"
        align="center"
      >
        <van-col span="12">
          <span class="font12 money-color">&yen;</span>
          <span
            v-if="priceList&&priceList[0]"
            class="font22 money-color"
          >
            {{ priceList[2].price }}
          </span>
          &nbsp;
          <span
            @click="$refs['tabbar'].toggle()"
            class="font12"
          >
            <span>{{ $t('E006','明细') }}  </span>
            <van-icon
              name="arrow-up"
              class="vertical-middle"
              size="14"
            />
          </span>
        </van-col>

        <van-col
          span="6"
          class="pad-5"
        >
          <ld-button
            defaults
            size="md"
            v-if="orderDetail.showCancelButton==1"
            @click.native="cancel()"
          >
            {{ $t('B008','取消') }}
          </ld-button>
        </van-col>
        <van-col
          span="6"
          class="pad-5"
        >
          <ld-button
            main
            size="md"
            v-if="orderDetail.showPayBtn==1"
            @click.native="toPay"
          >
            {{ $t('B014','支付') }}
          </ld-button>
        </van-col>

      </van-row>
    </ld-tabbar>
    <!--  -->

    <!-- 支付 -->
    <!-- <ld-pay
      ref="pay"
      order-type="11018"
      :order-id="orderId"
    /> -->

    <!--  -->
    <!-- 原因  -->
    <cancel-rason
      ref="cancelRason"
      @selected="chooseRason"
    />
  </div>
</template>
<script>
import ldHeader from 'Common/ldHeader'
import ldButton from 'Common/ldButton'
import cancelRason from '../carOrder/components/cancelRason.vue'
// import ldPay from 'Components/ldPay/index.vue'
import {Cell,Field} from 'vant'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import { mapGetters } from 'vuex'

export default {
  name:'TkCmp',
  components: {
    [Cell.name]:Cell,
    [Field.name]:Field,
    ldHeader,
    ldButton,
    // ldPay,
    ldTabbar,
    cancelRason
  },
  data:function(){
    return {
      queryInfo:{},                 //查询信息
      carInfo:{},                 //预订的车的信息
      order:{
        orderNo:'',     //订单编号
        useType:'',             //日包还是线路包
        fromAddr:'',   //上车地点
        fromCity:'',            //上车城市名
        carType:'',          //用车车型
        price:'',                //订单价格
        fromDate:'',          //用车月-日
        week:'',               //周
        time:'',              //时间点
        useDate:'',                 //使用天数
        showPayBtn:0,
      },
      orderDetail:'',
    }
  },
  computed:{
    ...mapGetters({
      carSearchInfo: 'car/carSearchInfo',
      tripType: 'tripType',
    }),
    orderId(){
      return this.$route.query.orderId
    },
    priceList(){
      return this.carSearchInfo.priceList
    },
    scCity(){
      if(this.carSearchInfo.useType==0||this.carSearchInfo.useType==2){
        return this.carSearchInfo.arriveCityName
      }
      return ''
    },
    xcCity(){
      if(this.carSearchInfo.useType==1||this.carSearchInfo.useType==3){
        return this.carSearchInfo.departCityName
      }
      return ''
    },
  },
  created:function(){
    //获取订单详情
    this.getOrderDetail()
  },
  beforeDestroy(){
    this.$store.commit('car/CLEAR_ALL',{})
  },
  methods:{
    chooseRason(info) {
      if (info && info.value) {
        this.showReason = false
        this.$api['carOrder/orderCancel']({
          orderId: this.orderId,
          qxbh: info.value, // 取消原因id
          qxyy: info.text, // 取消原因描述
          sfqx: 1, // 是否取消
        }).then(() => {
          this.getOrderDetail()
        })
      }
    },
    cancel() {
      this.$api['carOrder/getCancelFee']({
        orderId: this.orderId,
      }).then((res) => {
        let cache = res.data || {}
        if (cache.khFine) {
          this.$dialog.confirm({
            title: '提示',
            message: `取消订单会产生罚金￥${cache.khFine}，是否继续取消订单？`,
          }).then(() => {
            this.toggle('cancelRason')
          }).catch(() => {
            // on cancel
          })
        } else {
          this.$dialog.confirm({
            title: '提示',
            message: '是否取消订单',
          }).then(() => {
            this.toggle('cancelRason')
          }).catch(() => {
            // on cancel
          })
        }
      }).catch(res => {
        if (res.errCode === '1801') {
          this.$dialog.confirm({
            title: '提示',
            message: '当前状态下取消用车罚金暂不确定，具体以取消后的为准。是否继续取消？',
          }).then(() => {
            this.toggle('cancelRason')
          }).catch(() => {
            // on cancel
          })
        }
      })
    },
    getOrderDetail:function(){
      this.$api['carOrder/orderDetail']({
        orderId:this.orderId
      }).then(res=>{
        this.orderDetail = res.data||{}
      })
    },
    toPay(){//支付
      this.$router.push({path:'/pay/payment',query:{orderType:'11018',orderId:this.orderId}})
      // this.$refs.pay.toggle()
    },
    toggle(name) {
      this.$refs[name].toggle()
    },
  },
  filters:{
    currency:function(val){
      return '￥'+val
    },
    weekFilter:function(val){
      switch (val){
        case 0:
          return '周日'
          break
        case 1:
          return '周一'
          break
        case 2:
          return '周二'
          break
        case 3:
          return '周三'
          break
        case 4:
          return '周四'
          break
        case 5:
          return '周五'
          break
        case 6:
          return '周六'
          break
        default:
          return val
      }
    },
    filterUseType:function(val){
      if(val==1){
        return '日包'
      }else if(val==2){
        return '半日包'
      }else if(val==3){
        return '线路包车'
      }else if(val==4){
        return '接机'
      }else if(val==5){
        return '送机'
      }

    }
  }

}
</script>
<style lang="less" scoped>
.carCmp{
}
.pad-8{
    padding: 8px;
}
.pad-b-20{
    padding-bottom: 20px;
}
.pad-b-5{
    padding-bottom: 5px;
}
.m-b-5{
	margin-bottom:5px;
}
.pad-lr-10{
	padding:0 10px;
}
</style>
